/* eslint-disable max-len */
import { SvgProps } from './types'

export const CellphoneMessageIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="66"
      height="64"
      viewBox="0 0 66 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <g clipPath="url(#clip0_1757_11492)">
        <path d="M64.8194 32.573C64.8194 36.329 61.7834 39.3711 58.035 39.3711H39.9477L28.6448 48.4331L29.7744 39.3711H26.3855C22.6371 39.3711 19.6011 36.329 19.6011 32.573V16.7129C19.6011 12.9569 22.6371 9.91479 26.3855 9.91479H58.035C61.7834 9.91479 64.8194 12.9569 64.8194 16.7129V32.573Z" stroke={drawColor} strokeWidth="2.65" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M35.4291 58.6208C35.4291 61.1227 33.4073 63.1486 30.9105 63.1486H6.03888C3.54209 63.1486 1.52026 61.1227 1.52026 58.6208V5.38716C1.52026 2.8853 3.54209 0.859375 6.03888 0.859375H30.9105C33.4073 0.859375 35.4291 2.8853 35.4291 5.38716" stroke={drawColor} strokeWidth="2.65" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2.64996 9.91479H16.2122" stroke={drawColor} strokeWidth="2.65" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2.64996 54.093H34.2995" stroke={drawColor} strokeWidth="2.65" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16.2122 58.6206H19.6012" stroke={drawColor} strokeWidth="2.65" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M35.4291 58.6208V49.5588" stroke={drawColor} strokeWidth="2.65" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M27.5151 18.9768H56.9054" stroke={drawColor} strokeWidth="2.65" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M27.5151 24.6431H56.9054" stroke={drawColor} strokeWidth="2.65" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M27.5151 30.3091H44.4728" stroke={drawColor} strokeWidth="2.65" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_1757_11492">
          <rect width="65" height="64" fill="white" transform="translate(0.666626 0.00390625)"/>
        </clipPath>
      </defs>
    </svg>
  )
}
